import { Layers } from "appworks/graphics/layers/layers";
import { LayerNames } from "game-layers";

export function ThemeLayerSetup() {
    Layers.setLayerOrderConfig({
        default: [
            LayerNames.Background,
            LayerNames.Jackpots,
            LayerNames.Banners,
            LayerNames.MatrixBackground,
            LayerNames.MatrixContent,
            LayerNames.MatrixForeground,
            LayerNames.SymbolAnimations,
            LayerNames.StepperLineDisplay,
            LayerNames.CelebrationContent,
            LayerNames.Rays,
            LayerNames.Header,
            LayerNames.Footer,
            LayerNames.BetBar,
            LayerNames.HamburgerMenu,
            LayerNames.Prompts,
            LayerNames.Skip,
            LayerNames.SmartButton,
            LayerNames.MuteButton,
            LayerNames.CelebrationForeground,
            LayerNames.BigWinEmitter,
            LayerNames.BigWinFirework,
            LayerNames.BigWinText,
            LayerNames.PaytableBackground,
            LayerNames.PaytableContent,
            LayerNames.MenusContent,
            LayerNames.SettingsMenuTemplate,
            LayerNames.Alerts,
        ]
    }, LayerNames);
}

